import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";
const API_URL = `/directions`;

const allDirections = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des directions :", error);
    handleHttpError(error, "Impossible de charger les directions.");
    return [];
  }
};

export const getAllDirectionsByActive = async (active) => {
  const url = `${API_URL}/active/${active}`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors de la récupération des directions actives (${active}) :`,
      error
    );
    handleHttpError(error, "Impossible de filtrer les directions par statut.");
    return [];
  }
};
const saveDirections = async (directionsData) => {
  try {
    const response = await api.post(API_URL, directionsData);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de la direction :", error);
    handleHttpError(error, "Impossible d’enregistrer la direction.");
    throw error;
  }
};

export const deleteDirections = async (directionsId) => {
  const url = `${API_URL}/${directionsId}`;
  try {
    await api.delete(url);
  } catch (error) {
    console.error(
      `Erreur lors de la suppression de la direction ID ${directionsId} :`,
      error
    );
    handleHttpError(error, "Impossible de supprimer la direction.");
    throw error;
  }
};
export const getIdDirections = async (directionsId) => {
  const url = `${API_URL}/${directionsId}`;
  try {
    await api.get(url);
  } catch (error) {
    console.error(
      `Erreur lors de la récupération de la direction ID ${directionsId} :`,
      error
    );
    handleHttpError(error, "Impossible de charger la direction.");
    throw error;
  }
};
export const updateDirections = async (directionsId, directionsData) => {
  const url = `${API_URL}/${directionsId}`;
  try {
    const response = await api.put(url, directionsData);
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors de la mise à jour de la direction ID ${directionsId} :`,
      error
    );
    handleHttpError(error, "Impossible de mettre à jour la direction.");
    throw error;
  }
};
export const updateDisabledDirection = async (directionId, directionData) => {
  const url = `${API_URL}/disabled/${directionId}`;

  try {
    const response = await api.put(url, directionData);
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors de la désactivation de la direction ID ${directionId} :`,
      error
    );
    handleHttpError(error, "Impossible de désactiver la direction.");
    throw error;
  }
};

updateDisabledDirection;
export { saveDirections, allDirections };
